import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { RemoveArchiveAssets, UploadAssets } from '@apps/clos-sessions/state/archive-assets';
import { RemoveArchives } from '@apps/clos-sessions/state/archives';
import { FetchCloudSpace } from '@apps/clos-sessions/state/cloud';
import { ProductPurchase } from '@apps/clos-sessions/state/subscriptions';

@Injectable()
export class SyncCloudEffect implements OnDestroy {
  protected destroy$ = new Subject<void>();

  constructor(
    protected actions$: Actions,
    protected store: Store,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  use(): void {
    this.actions$
      .pipe(
        ofActionSuccessful(RemoveArchiveAssets, UploadAssets, RemoveArchives, ProductPurchase),
        tap(() => this.store.dispatch(new FetchCloudSpace())),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
